export default "__VITE_ASSET__WDVpnnD1__"